export default __webpack_public_path__ + "static/media/exhibition3.787916e8.png";